import { useTheme } from '@mui/material';

import type { IAccordionData } from '@rumblefish/ui/src/components/Rumblefish23Theme/Accordion/CustomizedAccordion.types';

export const faqData = {
  mainText: `FAQ`,
  description: `Dedicated development teams with Rumble Fish`,
};

export const AccordionData = (): IAccordionData[] => {
  const theme = useTheme();
  return [
    {
      title:
        'Q: What kind of development services models does Rumble Fish offer?',
      description: `A: Fintech—short for financial technology—refers to the integration of technology into offerings by financial services companies to improve their use and delivery to consumers. It represents a rapidly growing industry that uses technology to enhance financial activities. The primary goal of fintech is to make financial services more accessible, efficient, and user-friendly, leveraging innovations like mobile apps, artificial intelligence, blockchain, and big data.`,
      gradientOnFocus: theme.mixins.orangeGradient?.background as string,
    },

    {
      title: 'Q: Which cooperation model would be best for me?',
      customDescription: () => {
        return (
          <>
            A: The best cooperation model for you depends on your specific
            project requirements, timeline, and resource needs. At Rumble Fish,
            we offer several flexible engagement models to suit different
            situations:
            <ul>
              <li>
                <b>Staff Augmentation: </b>
                Ideal if you need to quickly enhance your in-house development
                team with additional expertise. This model allows you to scale
                your team up or down as needed, providing flexibility and
                immediate access to skilled developers.
              </li>
              <li>
                <b>Dedicated Team: </b>
                Perfect for long-term projects requiring continuous development
                and support. A dedicated team works exclusively on your project,
                fully integrated with your processes and culture, ensuring
                consistency and deep project understanding.
              </li>
              <li>
                <b>Project-Based Outsourcing: </b>
                Best for well-defined projects with specific goals and
                deadlines. Rumble Fish manages the entire development process
                from start to finish, delivering a complete solution based on
                your requirements. To determine the most suitable cooperation
                model, consider factors such as your project’s complexity, the
                required expertise, your in-house capabilities, and the level of
                control and involvement you wish to maintain. Our team can help
                you assess your needs and recommend the best approach to ensure
                a successful collaboration.
              </li>
            </ul>
          </>
        );
      },
      gradientOnFocus: theme.mixins.redGradient?.background as string,
    },

    {
      title:
        'Q: What are the benefits of enhancing my in-house development team with Rumble Fish developers?',
      description: `A: Enhancing your in-house development team with Rumble Fish developers provides fresh perspectives and specialized expertise, helps meet deadlines, and maintains high-quality standards. Our developers integrate seamlessly with your team, contributing their skills and knowledge to ensure project success.`,
      gradientOnFocus: theme.mixins.magentaGradient?.background as string,
    },

    {
      title: 'Q: How quickly can Rumble Fish developers join my project?',
      description: `A: Rumble Fish developers can join your project quickly, often within a few weeks. We understand the urgency of scaling development efforts and ensure that our skilled professionals are ready to contribute immediately, aligning with your project timelines and goals.
       `,
      gradientOnFocus: theme.mixins.purpleGradient?.background as string,
    },
    {
      title:
        'Q: Can Rumble Fish handle the entire development process for my project?',
      description: `A: Yes, the Rumble Fish development team can manage the entire process from start to finish. We assist with defining business goals, choosing the right tech stack, handling UI/UX design, and managing development, testing, and deployment. Our comprehensive services provide a seamless, worry-free experience.
      `,
      gradientOnFocus: theme.mixins.aquamarineGradient?.background as string,
    },
    {
      title:
        'Q: How do Rumble Fish developers integrate with my existing team and workflows? ',
      description: `A: Rumble Fish developers integrate seamlessly with your existing team and workflows by adapting to your processes and collaborating closely with your in-house staff. Our developers become valuable team members who understand your business goals and work collaboratively to achieve them, ensuring smooth and efficient project execution.`,
      gradientOnFocus: theme.mixins.blueGradient?.background as string,
    },
  ];
};
